import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderFulfillmentStatus, OrderMethod } from '../../services/exports/Constants';
import { useOngoingOrders } from '../../providers/OngoingOrdersProvider';
import { Button, Modal } from 'antd';

export default function CompleteOrderModal({ order, toggleModal }) {
  const { t } = useTranslation(null, { keyPrefix: 'Modals:Order:CompleteOrderModal' });

  const { markOrderComplete } = useOngoingOrders();
  const [loading, setLoading] = useState(false);

  const title = useMemo(() => {
    if (order.fulfillment_status === OrderFulfillmentStatus.Rejected) {
      return t(`text.status.${order.fulfillment_status}`);
    }

    return order.method === OrderMethod.Delivery
      ? t(`text.${order.method}.${order.delivery_provider}`)
      : t(`text.${order.method}`);
  }, [order.method, order.delivery_provider, order.fulfillment_status]);

  async function onApprove() {
    setLoading(true);
    const { success } = await markOrderComplete(order);
    setLoading(false);

    if (success) {
      toggleModal();
    }
  }

  return (
    <Modal open centered onClose={() => toggleModal()} footer={null} closeIcon={null}>
      <h5 className="w-full text-center">{title}</h5>
      <div className="flex gap-md mt-xl mx-auto w-fit">
        <Button type="text" onClick={() => toggleModal()} size="large" className="w-fit">
          {t('buttons.cancel')}
        </Button>
        <Button type="primary" onClick={onApprove} loading={loading} size="large" className="w-fit">
          {t('buttons.confirm')}
        </Button>
      </div>
    </Modal>
  );
}
